import React, { useState } from 'react';

function Tabs(props) {
  const { children, intialActiveTab } = props; // active is selected here to reduce the mistake of keeping mutiple tabs active at the same time
  const [activeTab, setActiveTab] = useState(intialActiveTab);

  return (
    <div>
      <div style={{display: 'flex'}}>
        {children.map((child, index) => {
          const { props: { title, tabKey } } = child;
          const isActive = tabKey === activeTab;

          const defaultHeadingStyle = {
            flex: 1,
            textAlign: 'center',
            borderBottom: '1px solid #009b00',
            padding: 5,
            cursor: 'pointer',
            outline: 'none'
          };

          const activeHeadingStyle = {
            ...defaultHeadingStyle,
            color: '#006600',
            borderBottom: '2px solid #009b00',
            boxShadow: '0px 0 6px 2px #009b00',
            cursor: 'text'
          };

          const customHeadingStyle = isActive ? activeHeadingStyle : defaultHeadingStyle;

          return (
            <div style={customHeadingStyle} key={tabKey} tabIndex={0} onClick={() => setActiveTab(tabKey)}>
              {title}
            </div>
          );
        })}
      </div>
      {children.filter((child) => {
        const {props: {tabKey}} = child;
        return tabKey === activeTab;
      })}
    </div>
  );
}

export function TabPane(props) {
  const {children, style} = props;
  return (
    <div style={style}>
      {children}
    </div>
  );
}

Tabs.TabPane = TabPane;

export default Tabs;